import { Divider, Typography } from 'antd';
import React from 'react';

interface NotificationInformationProps {
  title: string;
  description?: string | number;
}

const NotificationInformation: React.FC<NotificationInformationProps> = (props: NotificationInformationProps) => {
  const { title, description } = props;
  return (
    <>
      <div>
        <Typography.Text strong style={{ display: 'block', margin: '8px 0' }}>{title}</Typography.Text>
        <Typography.Paragraph style={{ wordWrap: 'break-word', marginBottom: 0 }}>
          {description}
        </Typography.Paragraph>
      </div>
      <Divider style={{ margin: '16px 0' }} />
    </>
  );
};

NotificationInformation.defaultProps = {
  description: '',
};

export default NotificationInformation;
